import { render, staticRenderFns } from "./FormImageEdit.vue?vue&type=template&id=845fccbc&"
import script from "./FormImageEdit.vue?vue&type=script&lang=js&"
export * from "./FormImageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports